export const ENRICHMENT_BATCH_SIZE = 10;
export const CALENDAR_WINDOW_DAYS = 8;
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export const MIN_HISTORY_DAYS_FOR_PREDICTION = 30;

export const VALID_TIMEZONES = [
  "Europe/Paris",
  "Europe/Brussels",
  "Europe/Zurich",
  "Europe/Berlin",
  "Europe/Stockholm",
  "Europe/Copenhagen",
  "Indian/Reunion",
  "UTC",
  "Europe/London",
  "Europe/Madrid",
];

export const DEFAULT_TIMEZONE = "Europe/Paris";
